module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/store_images/4@2x_c6f2a53ebd5df50a6d569d8660a457bb.png";